import React, { useEffect } from 'react';
import './App.css';
import RootNavigator from './navigation/root';
import {Provider} from 'react-redux';
import {store} from './redux/store';
import './i18n';
import { reloadKiosk } from './helpers/kiosk';
import { useKioskReload } from './hooks/useKioskReload';
import { useFreezeWatchdog } from './hooks/useFreezeWatchdog';
function App() {

  // Recarga programada (solo con el kiosco inactivo) + watchdog de pantalla congelada.
  useKioskReload();
  useFreezeWatchdog();

  // El registro del service worker iba en el cuerpo del componente: se volvía a suscribir a
  // 'load' en cada render. Ahora corre una sola vez.
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    const register = () => {
      navigator.serviceWorker.register('/service-worker.js')
        .then((registration) => {
          // Verificar si hay una nueva versión disponible
          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (!installingWorker) return;
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  // Nueva versión disponible
                  console.log('Nueva versión disponible.');
                  reloadKiosk('nueva versión del service worker');
                } else {
                  // Contenido cacheado por primera vez
                  console.log('Contenido cacheado por primera vez.');
                }
              }
            };
          };
        })
        .catch((error) => console.error('Error al registrar el Service Worker:', error));
    };

    if (document.readyState === 'complete') {
      register();
    } else {
      window.addEventListener('load', register, { once: true });
    }
  }, []);


  useEffect(() => {
    getStorage();
  }, []);

  const getStorage = async () => {
    if ('storage' in navigator && 'estimate' in navigator.storage) {
      const estimate =  await navigator.storage.estimate();
      console.log(`Uso actual: ${estimate.usage} bytes`);
      console.log(`Cuota total: ${estimate.quota} bytes`);

      if (estimate.usage / estimate.quota > 0.9) {
        console.warn('Almacenamiento casi lleno. Considera liberar espacio.');
      }
    }

    if ('storage' in navigator && 'persist' in navigator.storage) {
      const isPersisted = await navigator.storage.persist();
      console.log(`Almacenamiento persistente habilitado: ${isPersisted}`);
    }

  }

  return (
    <div className="App">
      <Provider store={store}>
        <RootNavigator  />
      </Provider>
    </div>
  );
}

export default App;
